module.exports = __webpack_public_path__ + "static/media/nGroupIcon.e8e9e5cb.svg";